import { Globe } from "lucide-react";

import { Button } from "@/components/ui/button";
import useOnboardingData from "@/store/onboarding-data";
import { Link } from "react-router";

const Topbar = () => {
    const { storeData } = useOnboardingData();

    return (
        <div className="fixed top-0 z-20 flex h-16 w-full items-center justify-between border-b bg-white px-4">
            <Link to={"/"}>
                <img src="/assets/images/logo/shoe-ai-logo.png" alt="logo" width={200} height={40} className="h-8 w-24" />
            </Link>
            <Button
                onClick={() => {
                    throw new Error("This is your second error!");
                }}
                variant={"outline"}
                className="text-xs md:text-md max-w-1/2"
            >
                <Globe />
                <h4 className="truncate">{storeData?.name || "Loading..."}</h4>
            </Button>
        </div>
    );
};

export default Topbar;
